import React from 'react';
import { useIsSA } from '../../lib/userState';

/**
 * Renders children only for visitors we have positively confirmed to be
 * in South Australia (manual state pick or IP geo). Everyone else -
 * unknown location, bots, or a confirmed non-SA state - gets `fallback`
 * (null by default). Used to gate phone numbers, direct-call controls and
 * One on One Support CTAs that are SA-only.
 */
export const SAOnly = ({ children, fallback = null }) => {
  const isSA = useIsSA();
  return isSA ? children : fallback;
};

export default SAOnly;
